<template>
  <div id="app" :class="{ gray: appStores.appSetting.grayMode && $route.path == '/' }">
    <div id="top-point"></div>
    <!-- 多层router-view  都需设置 keep-alive -->
    <keep-alive :include="routerStores.cachedViews">
      <router-view> </router-view>
    </keep-alive>
  </div>
</template>
<script lang="ts" setup>
import { appInfo } from '@/stores/appInfo';
import { usePermissionStore } from '@/stores/routers';
import { userInfo } from '@/stores/userInfo';
import Auth from '@/utils/auth';
const routerStores = usePermissionStore();
const appStores = appInfo();
const userStore = userInfo();
onMounted(() => {
  // 监听滚动条位置
  window.addEventListener('scroll', scrollTop, true);
  document.addEventListener('visibilitychange', () => {
    // 页面切换时，检测token 是否存在  不存在则清空信息
    if (document.visibilityState === 'visible') {
      if (!Auth.getToken()) {
        userStore.clearUserInfo();
      }
    }
  });
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', scrollTop, true);
  document.removeEventListener('visibilitychange', () => {});
});
// 保存高度至全局
function scrollTop() {
  let scroll = document.documentElement.scrollTop || document.body.scrollTop;
  appStores.scrollTop = scroll;
}
function init() {
  if (
    location.host == import.meta.env.VITE_APP_DOMAIN.replace(/^(https?:|)\/\//, '') ||
    location.host == import.meta.env.VITE_APP_DOMAIN_POINT.replace(/^(https?:|)\/\//, '')
  ) {
    appStores.isInner = false;
  }
  if (location.host == import.meta.env.VITE_APP_DOMAIN_INNER.replace(/^(https?:|)\/\//, '')) {
    appStores.isInner = true;
  }
  appStores.getAppSet();
}

init();
</script>
<style lang="scss" scoped>
.gray:after {
  content: '';
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: grayscale(100%);
  pointer-events: none;
}
</style>
